module.exports = __webpack_public_path__ + "img/ico-join.fb0d2223.svg";